export const enumToObject = <T>(enumData: object): Record<string, T> => {
  const values = Object.values(enumData);
  const length = values.length / 2;
  return values.slice(0, length).reduce((acc, x, i) => {
    const value = values[i + length];
    return { ...acc, [x]: value };
  }, {});
};
